/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsFooterData } from './lds-footer.data';
import { ILdsFooterProps } from './lds-footer.props.autogenerated';

export interface ILdsFooterViewProps extends ILdsFooterProps<ILdsFooterData> {}

/**
 *
 * LdsFooter component
 * @extends {React.PureComponent<ILdsFooterProps<ILdsFooterData>>}
 */
class LdsFooter extends React.PureComponent<ILdsFooterProps<ILdsFooterData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsFooter;
